export const GENRES = ["northern_soul","rare_soul","modern_soul","deep_soul","funk","disco","boogie","crossover_soul","r_and_b","motown","gospel","latin","soulful_house"];
export const TYPES = ["alldayer","allnighter","weekender","live_show","record_fair"];
export const RADII = [25, 50, 100];
export const PAGE_SIZE = 24;

export function isoDate(d) { return d.toISOString().slice(0, 10); }

export function weekendRange(base = new Date()) {
  const d = new Date(base); d.setHours(0, 0, 0, 0);
  const dow = (d.getDay() + 6) % 7; // Mon=0
  const fri = new Date(d); fri.setDate(d.getDate() + ((4 - dow + 7) % 7));
  if (dow >= 4) fri.setTime(d.getTime());
  const sun = new Date(fri); sun.setDate(fri.getDate() + (6 - ((fri.getDay() + 6) % 7)));
  return { date_from: isoDate(fri), date_to: isoDate(sun) };
}

export function monthRange(ym) {
  const [y, m] = ym.split("-").map(Number);
  const last = new Date(y, m, 0).getDate();
  return { date_from: `${ym}-01`, date_to: `${ym}-${String(last).padStart(2, "0")}` };
}

export function nextMonths(n = 12) {
  const out = []; const d = new Date();
  for (let i = 0; i < n; i++) { const x = new Date(d.getFullYear(), d.getMonth() + i, 1); out.push(`${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}`); }
  return out;
}

export function toParams(f) {
  const p = {};
  if (f.q) p.q = f.q;
  if (f.genre) p.genre = f.genre;
  if (f.event_type) p.event_type = f.event_type;
  if (f.country) p.country = f.country;
  if (f.date_from) p.date_from = f.date_from;
  if (f.date_to) p.date_to = f.date_to;
  if (f.lat != null && f.lng != null && f.radius_km) { p.lat = f.lat; p.lng = f.lng; p.radius_km = f.radius_km; }
  else if (f.city) p.city = f.city;
  return p;
}
